<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            测试用例：{{ $t('test', '默认值') }}
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="moduleId"
                    label="配置模块"
                >
                    <RemoteSelect
                        filterable
                        clearable
                        remote="/rs/languageModule/data"
                        placeholder="请选择"
                        :props="{id:'id',name:'moduleName'}"
                        v-model="queryFormModel.moduleId"
                    />
                </el-form-item>
                <el-form-item
                    prop="entryName"
                    label="条目名称"
                >
                    <el-input
                        v-model="queryFormModel.entryName"
                        placeholder="请输入条目名称"
                    />
                </el-form-item>
                <el-form-item
                    prop="entryKey"
                    label="条目值"
                >
                    <el-input
                        v-model="queryFormModel.entryKey"
                        placeholder="请输入条目值"
                    />
                </el-form-item>
                <el-form-item
                    prop="entryTrans"
                    label="译文"
                >
                    <el-input
                        v-model="queryFormModel.entryTrans"
                        placeholder="请输入译文"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 操作 -->
            <div
                class="ma-b"
            >
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        size="small"
                        @click="$router.push('/rs/language/languageEntry/edit/')"
                    >
                        新增
                    </el-button>
                    <el-button
                        type="danger"
                        icon="el-icon-delete"
                        size="small"
                        @click="onDelete"
                        :disabled="!currentTableSelect.length"
                    >
                        删除
                    </el-button>
                </el-button-group>
            </div>

            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
                @selection-change="onTableSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="39"
                />
                <el-table-column
                    prop="moduleName"
                    label="模块名称"
                    min-width="120"
                />
                <el-table-column
                    prop="entryKey"
                    label="条目key值"
                    min-width="100"
                />
                <el-table-column
                    prop="entryName"
                    label="条目名称"
                    min-width="120"
                />
                <el-table-column
                    prop="entryDesc"
                    label="条目描述"
                    min-width="150"
                />
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="120"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="$router.push(`/rs/language/languageEntry/edit/${scope.row.id}`)"
                        >
                            编辑
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableDelete(scope.row.id)"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'LanguageEntry',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                moduleId: '',
                entryName: '',
                entryKey: '',
                entryTrans: '',
            },
            // 表格数据
            tableData: [],
            // 表格当前选中行
            currentTableSelect: [],
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Rs.LanguageEntry.data(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
        onTableSelectionChange(val) {
            this.currentTableSelect = val;
        },
        onTableDelete(ids) {
            this.$confirm('是否确定要删除！', '温馨提示', {
                type: 'warning',
            }).then(() => {
                this.$api.Rs.LanguageEntry.delete({ ids }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                });
            });
        },
        onDelete() {
            const ids = this.currentTableSelect.reduce((prev, next) => {
                prev.push(next.id);
                return prev;
            }, []);
            this.onTableDelete(ids.join(','));
        },
    },
};
</script>

<style lang="scss">
</style>
